import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
// Props
import { PointsEachPart } from './PointsEachPart';

export const ListMultiTourParts = (props) => {
  const { prevPoly, edit, tr } = props;

  const activePartParts = useSelector(
    (store) => store.tourFullData.activeMultiPart.parts
  );
  const activePointId = useSelector(
    (store) => store.tourFullData.activePoint.id
  );
  const activePointPart = useSelector(
    (store) => store.tourFullData.activePoint.part
  );

  const ref = useRef(null);

  const selectId = activePointId || 0;
  const partPos = activePointPart ? activePointPart - 1 : null;

  const setRef = (link, isActive) => {
    if (isActive) ref.current = link;
  };

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'instant',
        block: 'nearest',
      });
    }
  }, [partPos]);

  const getMultiTourParts = () => {
    const parts = activePartParts || prevPoly.parts;
    if (parts.length > 0) {
      return parts.map((part, pos) => {
        const { id, title, points, distance, duration } = part;
        const isActive = partPos === pos;
        const classic = isActive
          ? 'list_item_wrap_multi_part hovered'
          : 'list_item_wrap_multi_part';
        return (
          <div
            key={id || pos}
            className={classic}
            ref={(ref) => setRef(ref, isActive)}
          >
            <PointsEachPart
              tr={tr}
              points={points}
              edit={edit}
              idSelectedPoint={selectId}
              part={{ title, num: pos + 1, id, distance, duration }}
              key={`${id + title}`}
              tour
            />
          </div>
        );
      });
    }
    return null;
  };

  return (
    <div className="tourFullPoints">
      <div className="tourFullPointsScroll parts">{getMultiTourParts()}</div>
    </div>
  );
};

ListMultiTourParts.propTypes = {};
